package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.FlagPt: ImageVector
    get() {
        if (_flagPt != null) {
            return _flagPt!!
        }
        _flagPt = Builder(name = "FlagPt", defaultWidth = 512.0.dp, defaultHeight = 512.0.dp,
                viewportWidth = 512.0f, viewportHeight = 512.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFF006600)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 0.0f)
                    lineTo(204.8f, 0.0f)
                    lineTo(204.8f, 512.0f)
                    lineTo(0.0f, 512.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFF0000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(204.8f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    lineTo(512.0f, 512.0f)
                    lineTo(204.8f, 512.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFE000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(104.8f, 256.0f)
                    arcTo(100.0f, 100.0f, 0.0f, false, true, 304.8f, 256.0f)
                    arcTo(100.0f, 100.0f, 0.0f, false, true, 104.8f, 256.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFF0000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(126.8f, 256.0f)
                    arcTo(78.0f, 78.0f, 0.0f, false, true, 282.8f, 256.0f)
                    arcTo(78.0f, 78.0f, 0.0f, false, true, 126.8f, 256.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(172.8f, 210.0f)
                    lineTo(236.8f, 210.0f)
                    lineTo(236.8f, 268.0f)
                    arcTo(32.0f, 32.0f, 0.0f, false, true, 172.8f, 268.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF002B7F)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(188.8f, 228.0f)
                    lineTo(220.8f, 228.0f)
                    lineTo(220.8f, 266.0f)
                    arcTo(16.0f, 16.0f, 0.0f, false, true, 188.8f, 266.0f)
                    close()
                }
            }
        }
        .build()
        return _flagPt!!
    }

private var _flagPt: ImageVector? = null
